<template>
  <Modal title="查看上课时间" v-model="visible" width="450">
      <Form ref="form" class="form" :label-width="100">
        <Row>
          <Col :span="24" >
            <Form-item label="买断时间" style="margin-bottom:0px">
              <Row>
                <Col :span="10" v-for="item in openedTimeList" :key="item.week" >
                  <label >
                    {{ item.weekStr }} {{ item.startTimeStr }} - {{ item.endTimeStr }}
                  </label>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="24" >
            <Form-item label="加课时间" style="margin-bottom:0px">
              <Checkbox-group v-model="randomOpenedTimeIdList">
                <Checkbox v-for="item in randomOpenedTimeList" :key="item.id" :label="item.id">
                  <span>{{ item.startTimeStr }} - {{ item.endTimeStr }}</span>
                </Checkbox>
              </Checkbox-group>
              <div style="margin-top: 6px">
                <Button size="small" @click="selectAll">全选</Button>
                <Button size="small" @click="invertSelect" style="margin-left: 8px">反选</Button>
              </div>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="visible=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingCancel" @click="canceOpenedTime">保存</Button>
      </div>
    </Modal>
</template>
<script>
  export default {
    name: 'TchCancelRandomOpenedTimeModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingCancel: false,
        openedTimeList: [],
        randomOpenedTimeIdList: [],
        randomOpenedTimeList: []
      }
    },
    methods: {
      selectAll () {
        this.randomOpenedTimeIdList = this.randomOpenedTimeList.map(item => item.id)
      },
      invertSelect () {
        const allIds = this.randomOpenedTimeList.map(item => item.id)
        this.randomOpenedTimeIdList = allIds.filter(id => !this.randomOpenedTimeIdList.includes(id))
      },
      loadRandomOpenedTime (row) {
        let loadMsg = this.$Message.loading({
          content: '正在加载中...',
          duration: 0
        })
        let self = this
        self.openedTimeList = []
        self.randomOpenedTimeList = []
        self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.openedTimeList = res.data
        })
        self.$http.get('/tch/randomOpenedTime?tchId=' + self.tchId).then(function (res) {
          if (!res || !res.data) {
            return
          }
          loadMsg()
          self.visible = true
          self.randomOpenedTimeList = res.data
        })
      },
      canceOpenedTime () {
        let self = this
        let ids = []
        let randomOpenedTimeIdList = this.randomOpenedTimeIdList
        this.randomOpenedTimeList.forEach(element => {
          randomOpenedTimeIdList.includes(element.id) || ids.push(element.id)
        })
        if (ids.length <= 0) {
          self.visible = false
          return 
        }
        self.loadingCancel = true
        let params = {}
        params.tchId = self.tchId
        params.randomOpenedTimeIds = ids.join(',')
        self.$http.post('/tch/time/cancelBookRandomOpenedTime', params).then(function (res) {
          self.loadingCancel = false
          let data = res.data
          if (data || data.length <= 0) {
            self.successCallback()
            self.visible = false
          } else {
            let content = '与学生上课时间冲突：</br>'
            data.forEach(element => {
              content += ('<b>' + self.$constant.weekZh[element.week] + ' ' + 
                self.$moment.unix(element.startTime).utc().format('HH:mm') + ' - ' +
                self.$moment.unix(element.endTime).utc().format('HH:mm')) + '</b></br>'
            })
            self.$Message.error({
              content: content,
              duration: 3
            })
          }
        })
      }
    },
    watch: {
      value (val) {
        this.openedTimeList = []
        this.randomOpenedTimeIdList = []
        this.randomOpenedTimeList = []
        if (val === true) {
          this.loadRandomOpenedTime()
        } else {
          this.visible = val
        }
      },
      visible (val) {
        this.$emit('input', val)
      },
      openedTimeList (val) {
        let self = this
        val.forEach(function (element) {
          element.weekStr = self.$constant.weekZh[element.week]
          element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm')
          element.endTimeStr = self.$moment.unix(element.endTime).utc().format('HH:mm')
        })
      },
      randomOpenedTimeList (val) {
        let self = this
        self.randomOpenedTimeIdList = []
        val.forEach(function (element) {
          self.randomOpenedTimeIdList.push(element.id)
          element.startTimeStr = self.$moment(element.startTime, 'X').format('YYYY-MM-DD HH:mm')
          element.endTimeStr = self.$moment(element.endTime, 'X').format('YYYY-MM-DD HH:mm')
        })
      }
    }
  }  
</script>



// WEBPACK FOOTER //
// TchCancelRandomOpenedTimeModal.vue?78c96cfe